import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<path className="body fill" fill="#FFFFFF" d="M237.90427,230.70677c59.72092,0,93.22128,47.7094,93.22128,89.57094
				c0,25.87775-19.16122,65.4527-93.22128,65.4527s-93.22127-39.57495-93.22127-65.4527
				C144.683,278.41617,178.18336,230.70677,237.90427,230.70677z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Seal/Bodies.js